var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Button, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import _countBy from 'lodash/countBy';
import _filter from 'lodash/filter';
import _find from 'lodash/find';
import _findKey from 'lodash/findKey';
import _forEach from 'lodash/forEach';
import { Component } from 'react';
import { Field, FieldArray, Form, reduxForm, } from 'redux-form';
import validUrl from 'valid-url';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import InputField from 'components/shared/util/InputField';
import { getRequestID } from 'components/shared/util/request';
const validate = (values) => {
    const errors = {};
    //console.warn("validate: ", values);
    if (!values.urls || !values.urls.length) {
        errors.urls = {
            _error: 'At least one URL must be entered - click on "Add URL"',
        };
    }
    else {
        const urlsArrayErrors = [];
        values.urls.forEach((url, index) => {
            const urlErrors = {};
            if (!url || !url.label) {
                urlErrors.label = 'Required';
                urlsArrayErrors[index] = urlErrors;
            }
            else if (!validUrl.isWebUri(url.label)) {
                urlErrors.label =
                    'Please add a valid url - most start with "http://" or "https://"';
                urlsArrayErrors[index] = urlErrors;
            }
        });
        const counts = _countBy(values.urls, (url) => url.label);
        let index = 0;
        _forEach(counts, (count) => {
            if (count > 1) {
                const urlErrors = {};
                urlErrors.label = "You can't have duplicate URLs";
                urlsArrayErrors[index] = urlErrors;
            }
            index++;
        });
        if (urlsArrayErrors.length) {
            errors.urls = urlsArrayErrors;
        }
    }
    return errors;
};
const ListUrls = ({ fields, meta: { error, touched, submitFailed }, }) => {
    return (_jsxs("div", { children: [_jsx("div", Object.assign({ className: "section-header mt10 mb10" }, { children: _jsx("h5", { children: "URLS" }) })), (touched || submitFailed) && error && _jsx("span", { children: error }), fields.map((url, index) => {
                return (_jsxs("div", Object.assign({ className: "input-field-url" }, { children: [_jsxs("div", Object.assign({ className: "m-b-5" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-danger btn-xm remove-url pull-right", title: "Remove URL", onClick: () => fields.remove(index) }, { children: _jsx(DixaIcon, { icon: "close" }) })), _jsxs("strong", { children: ["URL #", index + 1] })] })), _jsx(Field, { name: `${url}.label`, isRequired: true, type: "url", isDefaultChecked: `${url}.isDefault`, displayName: "URL address", placeholder: `Eg. http://www.yousite.com`, component: InputField, className: "form-control", label: "URL" })] }), index));
            }), _jsx(Button, Object.assign({ type: "button", variant: "secondary", style: { width: '100%' }, disabled: fields.length >= 12, onClick: () => fields.push({}) }, { children: "Add URL" }))] }));
};
class URLTriggerModal extends Component {
    handleSaveClick(values) {
        let defaultUrl = '';
        const newURLs = {};
        let nodeState;
        // @FIX - if fixing logic here, ChatMenuModal will probably need the same update
        const oldURLs = this.props.node.payload
            ? this.props.node.payload.urls
            : null;
        const formURLs = values.urls;
        _forEach(formURLs, (formURL) => {
            newURLs[formURL.label] = formURL.value || getRequestID();
        });
        if (oldURLs) {
            const doesNotExistAnymore = _filter(oldURLs, (oldNodeID) => !_find(newURLs, (newNodeID, newLabel) => newNodeID === oldNodeID));
            _forEach(doesNotExistAnymore, (urlNodeId) => {
                const urlLabel = _findKey(oldURLs, (id) => id === urlNodeId) || '';
                nodeState = this.props.updateConnectionLabel(nodeState, this.props.node, urlLabel, '');
            });
            _forEach(oldURLs, (oldNodeId, oldLabel) => {
                _forEach(newURLs, (newNodeId, newLabel) => {
                    if (newLabel === oldLabel && newNodeId !== oldNodeId) {
                        // if ID changed but label is the same, we sever the connection
                        // because FlowManager can't reason about which node to connect to
                        // or which actionnodes to delete otherwise
                        nodeState = this.props.updateConnectionLabel(nodeState, this.props.node, newLabel, '');
                        newURLs[newLabel] = getRequestID();
                    }
                    else if (newLabel !== oldLabel && newNodeId === oldNodeId) {
                        // if ID stayed the same but the label changed we update the connection with a new label
                        nodeState = this.props.updateConnectionLabel(nodeState, this.props.node, oldLabel, newLabel);
                    }
                });
            });
        }
        if (values.defaultUrl === undefined ||
            values.defaultUrl === null ||
            values.defaultUrl === '') {
            defaultUrl = getRequestID();
        }
        else {
            defaultUrl = values.defaultUrl;
        }
        const nodeOptions = Object.assign(Object.assign({}, this.props.node), { badges: [], icon: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.URL, payload: {
                urls: newURLs,
                defaultUrl,
            }, overlay: [], text: 'URL' });
        this.props.replaceNode(nodeOptions, nodeState);
        this.props.triggerClose();
    }
    closeModal() {
        const { destroy, triggerClose } = this.props;
        destroy();
        triggerClose();
    }
    render() {
        const { handleSubmit, node, nodeLabel, dirty: isChanged } = this.props;
        return (_jsx("div", Object.assign({ className: "url-trigger modal-chatflow-holder" }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(this.handleSaveClick) }, { children: [_jsxs(ModalHead, Object.assign({ title: nodeLabel, onClose: this.closeModal }, { children: ["URL triggers can be used to change how the chat widget looks and functions based on which URL the customer is at, when he or she starts the conversation.", _jsx("br", {}), _jsx("br", {}), "Eg. you can have one queue for your check-out pages and one for everything else. ", _jsx("i", { children: "https://example.com/support" }), " or", ' ', _jsx("i", { children: "https://example.com/checkout" })] })), _jsx(ModalBody, { children: _jsx(FieldArray, { name: "urls", component: ListUrls }) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(this.handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: this.closeModal })] })) })));
    }
}
__decorate([
    boundMethod
], URLTriggerModal.prototype, "handleSaveClick", null);
__decorate([
    boundMethod
], URLTriggerModal.prototype, "closeModal", null);
export default reduxForm({
    form: 'chatFlowUrlTriggerForm',
    enableReinitialize: true,
    validate,
})(URLTriggerModal);
